"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_KEY = void 0;
;
;
/**
 * The key used to indicate the default handler.
 */
exports.DEFAULT_KEY = 'default';
